mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    firstname
    lastname
    email
    phone
    role {
      id
      name
      slug
    }
  }
}
